module.exports = __webpack_public_path__ + "static/media/la.d190bfba.svg";